// extracted by mini-css-extract-plugin
export var addressFields = "_j3-0";
export var animationContainer = "_j3-1";
export var footer = "_j3-2";
export var lineItems = "_j3-3";
export var modalContent = "_j3-4";
export var orderName = "_j3-5";
export var strong = "_j3-6";
export var warning = "_j3-7";